if (!customElements.get('lsl-reassurance-carousel')) {
  customElements.define('lsl-reassurance-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.lsl-reassurance__track');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-detail]');
        if (trigger && this.contains(trigger)) {
          const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.detail));
          if (dialog && !dialog.open) {
            this.returnFocus = trigger;
            dialog.showModal();
          }
        }
        const close = event.target.closest('[data-close]');
        if (close) close.closest('dialog').close();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }), options);
      });
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.track);
      this.updateArrows();
      document.fonts.ready.then(() => { if (this.isConnected) this.updateArrows(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
    move(direction) {
      const trackRect = this.track.getBoundingClientRect();
      const positions = Array.from(this.track.children).map(item => item.getBoundingClientRect().left - trackRect.left + this.track.scrollLeft);
      const current = this.track.scrollLeft;
      const target = direction > 0 ? positions.find(position => position > current + 2) : positions.reverse().find(position => position < current - 2);
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({ left: Math.max(0, Math.min(target ?? (direction > 0 ? max : 0), max)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = max <= 2 || this.track.scrollLeft >= max - 2;
    }
  });
}
